import Toggle from './toggle';
import { IS_EASTER_TIME, TELEGRAM_GROUP_LINK } from 'const';
import Metadata from 'components/Metadata'
import EasterEgg from 'assets/art/EasterEgg_small.webp';
import './faq.scss';
import 'pages/styles.scss';

function FAQ() {
  return (
    <>
      <Metadata title="FAQ" link="/faq" description="Frequently Asked Questions about DogeBets" />
      <div className="FAQ">
        <div className="Body">
          <h2 className="text-2xl font-bold text-white text-left">FAQ</h2>
          <div className="QnAList">
            {/*
            <Toggle
              question="Why are there two referral pages?">
              <ul>
                <li>Our referrals are based on-chain.</li>
                <li>Because of that, there is a separate smart contract for each chain</li>
              </ul>
            </Toggle>

            <Toggle
              question="Do I have separate referrals on each chain?">
              <ul>
                <li>No. Our system is designed to seamlessly synchronize your referrals across chains</li>
                <li>
                  However, due to the on-chain implementation(user gets referred to you when they bet),
                  synchronization of your referrals happens when they bet cross-chain. Here's an example:
                </li>
                <li>
                  User A is referred to you. They played a game of BNB prediction on BSC and became referred to you there.
                  For them to become referred to you on DogeChain, they need to play any game there at least once, too.
                </li>
                <li>Please note, that it is not necessary for you to send them your referral link again</li>
                <li>
                  Please also note that this is an experimental feature and things can go wrong.
                  Report any issues you encounter in our <a href={TELEGRAM_GROUP_LINK}> Telegram community</a>
                </li>
              </ul>
            </Toggle>
            */}

            <Toggle
              question="How do I win?">
              <ul>
                <li>Wager BNB on whether the price of BNB-USDT will go UP or DOWN during the next round</li>
                <li>Choose correctly and claim your prize</li>
                <li>Prizes can be claimed from the Previous Card or the History page</li>
              </ul>
            </Toggle>

            <Toggle
              question="Where do the prices come from?">
              <ul>
                <li>DogeBets uses the Binance API feed for real-time price updates </li>
                <li>This price source updates instantly and will always match the Binance BNB-USDT, BTC-USDT and DOGE-USDT charts</li>
                <li><a href='https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT'>https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT</a></li>
                <li><a href='https://api.binance.com/api/v3/ticker/price?symbol=BTCUSDT'>https://api.binance.com/api/v3/ticker/price?symbol=BTCUSDT</a></li>
              </ul>
            </Toggle>

            <Toggle
              question="How can I verify that you capture the prices accurately?">
              <ul>
                <li> Binance.com provides a historic price breakdown, to the second. It is available from below endpoint:{' '}
                  <a href='https://api.binance.com/api/v3/klines?symbol=BTCUSDT&interval=1s&limit=10&startTime=1745668682000&endTime=1745668683000'>
                    https://api.binance.com/api/v3/klines
                  </a>
                </li>
                <li>But, if you go to that link - you will see that it's not very user-friendly. In fact, it's this type of raw data that's used for building & showing historic price charts</li>
                <li>Because of that, we've made a custom price verification tool - that uses Binance's data, and shows it on our site.</li>
                <li>To use it - just click on any round number on the history page - it will open round's details.</li>
                <li>From there - find the price that you want to verify("start price" or "end price"), click on the questionmark next to it</li>
                <li>And in the new box that opens you'll see "verify". Clicking that will open the tool, which will tell you if the price is correct</li>
                <li>There will also be a direct link to the api.binance.com - which will have the raw unedited price data, which you can always verify for yourself.</li>
              </ul>
            </Toggle>

            <Toggle
              question="Where do the bets on new rounds come from?">
              <ul>
                <li>DogeBets places a random sized bet on both sides (UP and DOWN) each round</li>
                <li>The bet is placed as soon as the round is created, <b>before</b> any real player bets</li>
                <li>This allows anyone to play 24/7, even if no one other people are currently playing</li>
                <li>Exact house bet sizes can be verified on-chain, as they are supplied with every 'Execute' transaction</li>
              </ul>
            </Toggle>

            <Toggle
              question="How do referrals work?">
              <ul>
                <li>Referrals give you an opportunity to profit by bringing in more players</li>
                <li>For every player you bring, you will be rewarded with 1% of their future wagers.
                  These rewards will accumulate under your wallet address within our smart contract and can be redeemed whenever you like and as often as you like.
                </li>
                <li>In order for a player to become referred to you - just send them your referral link.
                  The player then simply needs to bet one time after following your link; this permanently refers their wallet to yours.
                </li>
                <li>Once they are referred to you, the track of referrals is kept fully on-chain</li>
                <li>Your referrals are manageable through <a href='bsc/referrals'>BSC referrals</a></li>
              </ul>
            </Toggle>

            <Toggle
              question="What is the smart contract address?">
              <ul>
                <li><a
                  href="https://bscscan.com/address/0xAfA97b96325AA5595061018f6AA3F64C612a83d9"
                  target='_blank' rel='noopener noreferrer'
                >
                  BTC game: 0xAfA97b96325AA5595061018f6AA3F64C612a83d9
                </a></li>
                <li><s>BNB game: 0x00C3b3E90f2c960D711891B3BD57917c7ACf4B15</s> disabled</li>
              </ul>
            </Toggle>

            <Toggle
              question="Audit. Is your smart contract audited?">
              <ul>
                <li>Yes, it is audited by RD Auditors(rdauditors.com)</li>
                <li>
                  <a
                    href='https://www.rdauditors.com/wp-content/uploads/2022/03/DogeBets-Smart-Contract-Security-Report.pdf'
                  >Audit summary
                  </a>
                </li>
              </ul>
            </Toggle>

            <Toggle
              question="What happens if a round ends in a tie?">
              <ul>
                <li>The round is automatically cancelled and eligble for reclaim</li>
                <li>House fees are not applied to reclaimed rounds</li>
                <li>Check the History page or the Previous card for the 'refund' buttom</li>
              </ul>
            </Toggle>

            <Toggle
              question="What is the house fee?">
              <ul>
                <li>There is a 5% "DogeHouse" fee on all claimed winnings</li>
                <li>The house fee only applies to winning rounds</li>
              </ul>
            </Toggle>

            <Toggle
              question="How are the payout ratios calculated?">
              <ul>
                <li>The payout ratios automatically update every time a bet is placed, and follow a simple formula:</li>
                <li>Example: Total bets = 2.5 BNB (1.0 BNB bet on DOWN, 1.5 BNB bet on UP)</li>
                <ul>
                  <li>UP payout = 2.5 / 1.5 = 1.66x</li>
                  <li>DOWN payout = 2.5 / 1.0 = 2.50x</li>
                </ul>
              </ul>
            </Toggle>

            <Toggle
              question="Are there any keyboard shortcuts?">
              <ul id='shortcuts'>
                <li>Yes, there are!</li>
                <li>C - chart/cards. Works only on the main game page. Cycles between chart and cards</li>
                <li>H - history. Works only on the prediction game pages.</li>
                <li>M - menu. Opens/closes site menu</li>
                <li>Backspace - back. Takes you to the previously-visited page. Works on frequently-visited pages. Prediction, history, round details.</li>
              </ul>
            </Toggle>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQ;
